export const scrollToAndFocus = (cssSelector, options = {}) => {
  const element = document.querySelector(cssSelector)
  element && setTimeout(() => {
    if (!['INPUT', 'SELECT'].includes(document.activeElement.tagName) && document.activeElement.role != 'option') {
      element.scrollIntoView({behavior: 'smooth', block: 'center'})
    }
    if (!options.skipFocus) {
      setTimeout(() => element.focus(), 600)
    }
  }, 300)
}
